export const openSourceList = [
  {
    name: 'jest-dom',
    url: 'https://github.com/testing-library/jest-dom',
    description: 'Custom jest matchers to test the state of the DOM used for Unit Test of react app.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-testing-library',
    url: 'https://github.com/testing-library/react-testing-library',
    description: 'Utilities for simple and complete React DOM testing',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-helmet',
    url: 'https://github.com/nfl/react-helmet',
    description: 'This reusable React component will manage all of your changes to the document head.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'amplify-js',
    url: 'https://github.com/aws-amplify/amplify-js',
    description:
      'This provides an APIs and building blocks  to create user authentication experiences for Web & Mobile application.',
    technology: 'REACT',
    license: 'APACHE 2.0',
  },
  {
    name: 'classnames',
    url: 'https://github.com/JedWatson/classnames',
    description:
      'A simple javascript utility for conditionally joining classNames together and we can apply those classnames to react component.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'formik',
    url: 'https://github.com/jaredpalmer/formik',
    description: 'It’s a form library to create form in react with validation middleware using Yup validator.',
    technology: 'REACT',
    license: 'APACHE 2.0',
  },
  {
    name: 'i18next',
    url: 'https://github.com/i18next/i18next',
    description: 'i18next is a internationalization framework.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'lodash',
    url: 'https://github.com/lodash/lodash',
    description:
      'It provides utilities which provide a simple solution while Iterating arrays, objects, & strings, Manipulating values of them etc..',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'qrcode',
    url: 'https://github.com/soldair/node-qrcode',
    description: 'Generates QR Code in various formats, such as images, data URLs and canvas elements.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'qrcode.react',
    url: 'https://github.com/zpao/qrcode.react',
    description: 'React Component to generates a QR Code for MFA.',
    technology: 'REACT',
    license: 'ISC',
  },
  {
    name: 'react',
    url: 'https://github.com/facebook/react',
    description: 'A declarative, efficient, and flexible JavaScript library for building user interfaces',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-bootstrap',
    url: 'https://github.com/react-bootstrap/react-bootstrap',
    description: 'Bootstrap components built with React to integrate in Driver & Admin portal.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-bootstrap-daterangepicker',
    url: 'https://github.com/skratchdot/react-bootstrap-daterangepicker',
    description:
      'React component for integrating a customizable date range picker with Bootstrap styling, allowing easy date selection in web applications.',
    technology: 'REACT',
    license: 'Apache-2.0',
  },
  {
    name: 'react-dom',
    url: 'https://github.com/facebook/react/tree/master/packages/react-dom',
    description:
      'This package serves as the entry point to the DOM and server renderers for React. It requires to create react app.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-i18next',
    url: 'https://github.com/i18next/react-i18next',
    description: 'React Components for Internationalization',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-promise-tracker',
    url: 'https://github.com/Lemoncode/react-promise-tracker',
    description: 'Simple promise tracker React Hook and Higher Order Component.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-redux',
    url: 'https://github.com/reduxjs/react-redux',
    description:
      'It creates a wrapper for managng store and interaction logic so we can use redux in react with minimal configuation. It’s mainly use for managing state of application.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-router',
    url: 'https://github.com/remix-run/react-router',
    description: 'It’s providing routing for react application',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-select',
    url: 'https://github.com/JedWatson/react-select',
    description: 'Select component for react app used in Admin & driver portal.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-select-async-paginate',
    url: 'https://github.com/vtaits/react-select-async-paginate',
    description: 'Wrapper above react-select that supports pagination on menu scroll.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-toastify',
    url: 'https://github.com/fkhadra/react-toastify',
    description: 'React-Toastify allows you to add notifications to your app with ease',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'redux',
    url: 'https://github.com/reduxjs/redux',
    description: 'State container for javascript apps',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'redux-auth-wrapper',
    url: 'https://github.com/mjrussell/redux-auth-wrapper',
    description:
      'A React Higher Order Component (HOC) for handling Authentication and Authorization with Routing and Redux',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'redux-devtools-extension',
    url: 'https://github.com/zalmoxisus/redux-devtools-extension',
    description: 'Used for debugging state on particular action and it’s only for development dependencies.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'redux-thunk',
    url: 'https://github.com/reduxjs/redux-thunk',
    description: 'It used for write Async logic that interacts with the store of redux.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'yup',
    url: 'https://github.com/jquense/yup',
    description: 'Dead simple Object schema validation',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'crypto-js',
    url: 'https://github.com/brix/crypto-js',
    description: 'JavaScript implementations of standard and secure cryptographic algorithms',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-cookie',
    url: 'https://github.com/bendotcodes/cookies',
    description: 'Utility to Load and save cookies within your React application.',
    technology: 'REACT',
    license: 'MIT',
  },

  {
    name: 'jquery',
    url: 'https://github.com/jquery/jquery',
    description:
      'jQuery is a fast, small, and feature-rich JavaScript library that simplifies tasks like HTML document traversal, event handling, and animation across different browsers.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'prop-types',
    url: 'https://github.com/facebook/prop-types',
    description:
      'prop-types is used for runtime type checking of react component props, helping to ensure they are used correctly.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-google-recaptcha',
    url: 'https://github.com/dozoisch/react-google-recaptcha',
    description:
      "react-google-recaptcha is a React component for integrating Google's reCAPTCHA to protect web applications from spam and abuse.",
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-number-format',
    url: 'https://github.com/s-yadav/react-number-format',
    description:
      'Ensures that a user can only enter text that meets specific numeric or string patterns, and formats the input value for display.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'reactstrap',
    url: 'https://github.com/reactstrap/reactstrap',
    description:
      'Provides Bootstrap 4 components as React components, making it easier to use Bootstrap with React applications',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: '@casl/ability',
    url: 'https://github.com/stalniy/casl',
    description: 'Handles user permissions and access control in web applications based on rules and abilities.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: '@casl/react',
    url: 'https://github.com/stalniy/casl',
    description: 'Provides Can component that allow to hide or show UI elements based on user ability to see them.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: '@craco/craco',
    url: 'https://github.com/dilanx/craco',
    description: 'Provides easy and comprehensible configuration layer for create-react-app.',
    technology: 'REACT',
    license: 'Apache-2.0',
  },
  {
    name: '@react-pdf/renderer',
    url: 'https://github.com/diegomura/react-pdf',
    description: 'Generates PDF documents using React components and styling',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: '@testing-library/user-event',
    url: 'https://github.com/testing-library/user-event',
    description: 'Simulate the real events that would happen in the browser as the user interacts with it',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'buffer',
    url: 'https://github.com/feross/buffer',
    description:
      'Provides a way to work with binary data, offering utilities to create, manipulate and interact with buffers',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'isomorphic-dompurify',
    url: 'https://github.com/kkomelin/isomorphic-dompurify',
    description:
      'Provides a secure and cross-platform solution for sanitizing HTML content to prevent XSS (Cross-Site Scripting) attacks',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'bootstrap',
    url: 'https://github.com/twbs/bootstrap',
    description:
      'Provides pre-designed, responsive UI components and layout styles for building modern and mobile-first web applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'bootstrap-daterangepicker',
    url: 'https://github.com/dangrossman/daterangepicker',
    description: 'Creates a dropdown menu from which a user can select a range of dates.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'draft-js',
    url: 'https://github.com/facebookarchive/draft-js',
    description:
      'Builds rich text editors, providing customizable features like text styling, links and media embedding.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'draftjs-to-html',
    url: 'https://github.com/jpuri/draftjs-to-html',
    description:
      'Converts Draft.js editor content into clean and formatted HTML and enabling seamless integration with web applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'fuse.js',
    url: 'https://github.com/krisk/Fuse',
    description:
      'Performing fuzzy searching on large datasets, offering fast and accurate results even with partial or misspelled queries.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'immutable',
    url: 'https://github.com/immutable-js/immutable-js',
    description:
      'Provides persistent data structures for JavaScript, enabling efficient updates and ensuring immutability for complex state management.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'leaflet',
    url: 'https://github.com/Leaflet/Leaflet',
    description:
      'Lightweight and open-source JavaScript library for creating interactive maps and adding geospatial features to web applications.',
    technology: 'REACT',
    license: 'BSD-2-Clause',
  },
  {
    name: 'react-color',
    url: 'https://github.com/casesandberg/react-color',
    description:
      'Provides customizable color pickers, offering various color selection tools like RGB, HEX and HSL for user-friendly interfaces.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-cookie-consent',
    url: 'https://github.com/Mastermindzh/react-cookie-consent',
    description: 'A small, simple and customizable cookie consent bar for use in React applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-csv',
    url: 'https://github.com/react-csv/react-csv',
    description:
      'Simplifies exporting data to CSV format, providing a component to easily generate and download CSV files from web applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-datepicker',
    url: 'https://github.com/Hacker0x01/react-datepicker',
    description:
      'Customizable React component for selecting dates and times, offering features like date range selection, localization and input validation.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-draft-wysiwyg',
    url: 'https://github.com/jpuri/react-draft-wysiwyg',
    description:
      'Provides a rich text editor built on top of Draft.js, offering a user-friendly WYSIWYG interface for text formatting and media embedding.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-icons',
    url: 'https://github.com/react-icons/react-icons',
    description:
      'Provides a collection of popular icon sets as React components, making it easy to integrate scalable vector icons into web applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-leaflet',
    url: 'https://github.com/PaulLeCam/react-leaflet',
    description:
      'Provides a collection of popular icon sets as React components, making it easy to integrate scalable vector icons into web applications.',
    technology: 'REACT',
    license: 'Hippocratic-2.1',
  },
  {
    name: 'react-places-autocomplete',
    url: 'https://github.com/hibiken/react-places-autocomplete',
    description: 'A React component to build a customized UI for Google Maps Places Autocomplete',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-scripts',
    url: 'https://github.com/facebook/create-react-app',
    description: 'Includes scripts and configuration used by Create React App.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-scrollbars-custom',
    url: 'https://github.com/xobotyi/react-scrollbars-custom',
    description:
      'Provides customizable and styled scrollbars, offering enhanced control over the appearance and behavior of scrollbars in web applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react18-json-view',
    url: 'https://github.com/YYsuni/react18-json-view',
    description: 'React component for displaying JSON data in an interactive and collapsible tree format.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'recharts',
    url: 'https://github.com/recharts/recharts',
    description: 'Creates customizable and responsive charts, using components to visualize data with ease.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'apexcharts',
    url: 'https://github.com/apexcharts/apexcharts.js',
    description:
      'Modern charting library for creating interactive, responsive and customizable charts in web applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'craco-esbuild',
    url: 'https://github.com/pradel/create-react-app-esbuild',
    description:
      'Plugin for craco that integrates esbuild for faster JavaScript and TypeScript bundling in React applications.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-countdown-circle-timer',
    url: 'https://github.com/vydimitrov/react-countdown-circle-timer',
    description: 'React component for displaying a customizable circular countdown timer with animated progress.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'react-error-boundary',
    url: 'https://github.com/bvaughn/react-error-boundary',
    description:
      'React component that provides a way to handle JavaScript errors in a graceful manner by displaying fallback UI when errors occur.',
    technology: 'REACT',
    license: 'MIT',
  },
  {
    name: 'resize-observer',
    url: 'https://github.com/devrelm/resize-observer',
    description: 'JavaScript API for detecting and reacting to changes in the size of an element or its viewport.',
    technology: 'REACT',
    license: 'Apache-2.0',
  },

  {
    name: 'websocket',
    url: 'https://github.com/theturtle32/WebSocket-Node',
    description:
      'Provides a simple and flexible WebSocket client and server implementation for real-time and full-duplex communication.',
    technology: 'REACT',
    license: 'Apache-2.0',
  },
  {
    name: 'sequelize',
    url: 'https://github.com/sequelize/sequelize',
    description: 'Sequelize is a node js based ORM for Postgres facilitates to perform DB operations.',
    technology: 'POSTGRESQL',
    license: 'MIT',
  },
  {
    name: '@cantoo/pdf-lib',
    url: 'https://github.com/cantoo-scribe/pdf-lib',
    description: 'Create and modify PDF documents in any JavaScript environment.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'form-data',
    url: 'https://github.com/form-data/form-data',
    description:
      'A library to create readable "multipart/form-data" streams. Can be used to submit forms and file uploads to other web applications.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'google-auth-library',
    url: 'https://github.com/googleapis/google-auth-library-nodejs',
    description: 'This library provides an implementation of Application Default Credentials (ADC) for Node.js.',
    technology: 'NODE',
    license: 'APACHE 2.0',
  },
  {
    name: 'node-html-parser',
    url: 'https://github.com/taoqf/node-html-parser',
    description:
      'Fast HTML Parser is a very fast HTML parser. Which will generate a simplified DOM tree, with element query support.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'pg',
    url: 'https://github.com/brianc/node-postgres',
    description: 'Non-blocking PostgreSQL client for Node.js. Pure JavaScript and optional native libpq bindings.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'rimraf',
    url: 'https://github.com/isaacs/rimraf',
    description: 'The UNIX command rm -rf for node in a cross-platform implementation.',
    technology: 'NODE',
    license: 'ISC',
  },
  {
    name: 'archiver',
    url: 'https://github.com/archiverjs/node-archiver',
    description: 'A streaming interface for archive generation',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'async-json2csv',
    url: 'https://github.com/solee0524/async-json2csv',
    description: 'A simple json to csv module to support async.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'axios-mock-adapter',
    url: 'https://github.com/ctimmerm/axios-mock-adapter',
    description: 'Axios adapter that allows to easily mock requests',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'compression',
    url: 'https://github.com/expressjs/compression',
    description: 'Node.js compression middleware.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'csvtojson',
    url: 'https://github.com/Keyang/node-csvtojson',
    description:
      'csvtojson module is a comprehensive nodejs csv parser to convert csv to json or column arrays. It can be used as node.js library / command line tool / or in browser',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 's3-zip',
    url: 'https://github.com/orangewise/s3-zip',
    description: 'Download selected files from an Amazon S3 bucket as a zip file.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'serverless-http',
    url: 'https://github.com/dougmoscrop/serverless-http',
    description:
      'This module allows you to wrap your API for serverless use. No HTTP server, no ports or sockets. Just your code in the same execution pipeline you are already familiar with.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'source-map-support',
    url: 'https://github.com/evanw/node-source-map-support',
    description:
      'This module provides source map support for stack traces in node via the V8 stack trace API. It uses the source-map module to replace the paths and line numbers of source-mapped files with their original paths and line numbers.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'eslint',
    url: 'https://github.com/eslint/eslint',
    description:
      'ESLint is a tool for identifying and reporting on patterns found in ECMAScript/JavaScript code. In many ways, it is similar to JSLint and JSHint with a few exceptions:',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'serverless-offline',
    url: 'https://github.com/dherault/serverless-offline',
    description:
      'This Serverless plugin emulates AWS λ and API Gateway on your local machine to speed up your development cycles. To do so, it starts an HTTP server that handles the request lifecycle like APIG does and invokes your handlers.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'serverless-offline-ssm',
    url: 'https://github.com/thoreinstein/serverless-offline-ssm',
    description:
      'This Serverless plugin allows you to develop offline while using AWS SSM parameters in your serverless.yml template.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'node-forge',
    url: 'https://github.com/digitalbazaar/forge',
    description:
      'The Forge software is a fully native implementation of the TLS protocol in JavaScript, a set of cryptography utilities, and a set of tools for developing Web Apps that utilize many network resources.',
    technology: 'NODE',
    license: 'BSD',
  },
  {
    name: '@sparticuz/chromium',
    url: 'https://github.com/Sparticuz/chromium',
    description:
      'The Chromium binary is compressed using the Brotli algorithm. This allows us to get the best compression ratio and faster decompression times.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'puppeteer-core',
    url: 'https://github.com/puppeteer/puppeteer/',
    description:
      'Puppeteer is a JavaScript library which provides a high-level API to control Chrome or Firefox over the DevTools Protocol or WebDriver BiDi. Puppeteer runs in the headless (no visible UI) by default',
    technology: 'NODE',
    license: 'APACHE 2.0',
  },
  {
    name: 'aws-sdk-js-v3',
    url: 'https://github.com/aws/aws-sdk-js-v3',
    description:
      'The official AWS SDK for JavaScript for Node.js backends to communicate with amazon service like S3, Cognito Identity.',
    technology: 'NODE',
    license: 'APACHE 2.0',
  },
  {
    name: 'express',
    url: 'https://github.com/expressjs/express',
    description: 'This is a node js module facilitates to implement routing for our serverless apis.',
    technology: 'NODE',
    license: 'APACHE 2.0',
  },

  {
    name: 'hapi-joi-to-swagger',
    url: 'https://github.com/zailtoncalheiros/hapi-joi-to-swagger',
    description: 'Conversion library for transforming Joi schema objects into Swagger schema definitions.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'moment',
    url: 'https://github.com/moment/moment',
    description: 'A lightweight JavaScript date library for parsing, validating, manipulating, and formatting dates.',
    technology: 'NODE  REACT',
    license: 'MIT',
  },
  {
    name: 'OpenAPI-Specification',
    url: 'https://github.com/OAI/OpenAPI-Specification',
    description:
      'The OpenAPI Specification (OAS) defines a standard, programming language-agnostic interface description for HTTP APIs, which allows both humans and computers to discover and understand the capabilities of a service without requiring access to source code, additional documentation, or inspection of network traffic.',
    technology: 'NODE',
    license: 'APACHE 2.0',
  },
  {
    name: 'node-postgres',
    url: 'https://github.com/brianc/node-postgres',
    description: 'Non-blocking PostgreSQL client for Node.js.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'pg-hstore',
    url: 'https://github.com/scarney81/pg-hstore',
    description: 'A node package for serializing and deserializing JSON data to hstore format.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'sequelize-mock',
    url: 'https://github.com/BlinkUX/sequelize-mock',
    description: 'A simple mock interface specifically for testing code relying on Sequelize models',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'winston',
    url: 'https://github.com/winstonjs/winston',
    description: 'A logger based on node js..',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'body-parser',
    url: 'https://github.com/expressjs/body-parser',
    description: 'Node.js body parsing middleware',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'celebrate',
    url: 'https://github.com/arb/celebrate',
    description: 'A joi validation middleware for Express facilitates to validate rules define using joi.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'serverless',
    url: 'https://github.com/serverless/serverless',
    description: 'Build web applications with serverless architectures using AWS Lambda, Azure Functions.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'node-source-map-support',
    url: 'https://github.com/evanw/node-source-map-support',
    description: 'Build web applications with serverless architectures using AWS Lambda, Azure Functions.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'node-jsonwebtoken',
    url: 'https://github.com/auth0/node-jsonwebtoken',
    description: 'An implementation of JSON Web Tokens it facilitates to encode/Decode Json Web Tokens.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'node-jwk-to-pem',
    url: 'https://github.com/Brightspace/node-jwk-to-pem',
    description: 'Convert a json web key to a PEM for use by OpenSSL or crytpo.',
    technology: 'NODE',
    license: 'APACHE 2.0',
  },
  {
    name: 'request',
    url: 'https://github.com/request/request',
    description: 'Simplified HTTP request client',
    technology: 'NODE',
    license: 'APACHE 2.0',
  },
  {
    name: 'axios',
    url: 'https://github.com/axios/axios',
    description: 'Promise based HTTP client for the browser and node.js',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'xml-js',
    url: 'https://github.com/nashwaan/xml-js',
    description: 'Converter utility between XML text and Javascript object / JSON text.',
    technology: 'NODE',
    license: 'MIT',
  },
  {
    name: 'uuid',
    url: 'https://github.com/uuidjs/uuid',
    description: 'Generate RFC-compliant UUIDs/ Token for generate token_b.',
    technology: 'NODE',
    license: 'MIT',
  },
];
